//Reset data
export const RESET = "DOSSIER_AFFECTATION_RESET"

export const SET_IS_UPDATED = "DOSSIER_AFFECTATION_SET_IS_CREATE"
export const SET_NOT_UPDATED = "DOSSIER_AFFECTATION_SET_NOT_CREATE"
export const SET_IS_CLOSED = "DOSSIER_CLOSE_SET_IS_CREATE"
export const SET_NOT_CLOSED = "DOSSIER_NOT_CLOSE_SET_IS_CREATE"


//Loading
export const SET_TOGGLE_LOADING = "DOSSIER_AFFECTATION_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "DOSSIER_AFFECTATION_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "DOSSIER_AFFECTATION_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "DOSSIER_AFFECTATION_SET_MESSAGE"
export const SET_IS_SUCCESS = "DOSSIER_AFFECTATION_SET_IS_SUCCESS"
export const SET_IS_ERROR = "DOSSIER_AFFECTATION_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "DOSSIER_AFFECTATION_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "DOSSIER_AFFECTATION_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "DOSSIER_AFFECTATION_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "DOSSIER_AFFECTATION_SET_UPDATE"
export const SET_CURRENT_ITEM = "DOSSIER_AFFECTATION_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "DOSSIER_AFFECTATION_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "DOSSIER_AFFECTATION_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "DOSSIER_AFFECTATION_SET_HIDE_MODAL"


export const SET_MODAL = "DOSSIER_AFFECTATION_SET_MODAL"
export const SET_MODAL_CONTENT = "DOSSIER_AFFECTATION_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "DOSSIER_AFFECTATION_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "DOSSIER_AFFECTATION_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "DOSSIER_AFFECTATION_SET_MODAL_TYPE"